// extracted by mini-css-extract-plugin
module.exports = {"wrap":"lm-z","articleImagesWrap":"mm-z","articleImage":"nm-z","singleImage":"om-z"};